import type { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import { calculateExcVatPrice } from '../../vat-rates/util/vatCalculations';
import type { UpsertBranchStockPriceDto } from '../types/BranchStockDto';

/**
 * Autopopulates the exc. VAT price fields from their inc. VAT counterparts using
 * the given VAT rate. Only recalculates a price the user has modified, so stored
 * and manually overridden exc. VAT values are left alone.
 */
export function useExcVatAutoCalc(
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>,
	prices: UpsertBranchStockPriceDto | undefined,
	vatRate?: number,
	pathPrefix = '',
) {
	const setExcVat = (fieldName: string, priceIncVat?: number) => {
		if (!form.isDirty(`${pathPrefix}priceIncVat${fieldName}`)) return;

		const excVat = calculateExcVatPrice(priceIncVat, vatRate);

		if (excVat !== undefined) {
			form.setFieldValue(`${pathPrefix}priceExcVat${fieldName}`, excVat);
		}
	};

	// biome-ignore lint/correctness/useExhaustiveDependencies: recalculate only when the inc. VAT price or rate changes
	useEffect(
		() => setExcVat('One', prices?.priceIncVatOne),
		[prices?.priceIncVatOne, vatRate],
	);
	// biome-ignore lint/correctness/useExhaustiveDependencies: recalculate only when the inc. VAT price or rate changes
	useEffect(
		() => setExcVat('Two', prices?.priceIncVatTwo),
		[prices?.priceIncVatTwo, vatRate],
	);
	// biome-ignore lint/correctness/useExhaustiveDependencies: recalculate only when the inc. VAT price or rate changes
	useEffect(
		() => setExcVat('Three', prices?.priceIncVatThree),
		[prices?.priceIncVatThree, vatRate],
	);
	// biome-ignore lint/correctness/useExhaustiveDependencies: recalculate only when the inc. VAT price or rate changes
	useEffect(
		() => setExcVat('Four', prices?.priceIncVatFour),
		[prices?.priceIncVatFour, vatRate],
	);
}
